import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Form as FormikForm,
  FormItem,
  Radio,
  DatePicker,
  Select,
} from 'formik-antd';
import { dateFormat } from 'utils/dates';
import { Fieldset } from 'components/form';
import { Tooltip, Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import StagePropTypes from './prop-types';
import { DB_PREFIX, DB_PREFIX_VACCINATED } from './constants';

const Form = ({ isSubmitting, values, setFieldValue, children }) => {
  const { vaccinated } = values[DB_PREFIX_VACCINATED];
  return (
    <FormikForm layout="vertical">
      <FormItem
        label="Have you been vaccinated?"
        name={`${DB_PREFIX_VACCINATED}.vaccinated`}
      >
        <Radio.Group
          name={`${DB_PREFIX_VACCINATED}.vaccinated`}
          defaultValue="a"
        >
          <Radio.Button value={false}>No</Radio.Button>
          <Radio.Button value>Yes</Radio.Button>
        </Radio.Group>
      </FormItem>

      {vaccinated === true ? (
        <>
          <FormItem name={`${DB_PREFIX}.vaccineType`} label="Vaccine type">
            <Select
              name={`${DB_PREFIX}.vaccineType`}
              placeholder="Please select which vaccine you have had"
            >
              <Select.Option key="Pfizer/BioNTech" value="Pfizer/BioNTech">
                Pfizer/BioNTech
              </Select.Option>
              <Select.Option
                key="Oxford/AstraZeneca"
                value="Oxford/AstraZeneca"
              >
                Oxford/AstraZeneca
              </Select.Option>
            </Select>
          </FormItem>

          <Fieldset>
            <FormItem
              name="vaccineDateFirst"
              label={<span>Date of first vaccination</span>}
            >
              <DatePicker
                style={{ width: '100%' }}
                name={`${DB_PREFIX}.vaccineDateFirst`}
                format={dateFormat}
                defaultPickerValue={moment().clone().set('year', 2020)}
              />
            </FormItem>

            <FormItem
              name="vaccineDateSecond"
              label={
                <span>
                  Date of second vaccination
                  <Tooltip title="Leave blank if not yet scheduled - (remember to come back and update your profile when 2nd dose of vaccination carried out)">
                    <InfoCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              <DatePicker
                style={{ width: '100%' }}
                name={`${DB_PREFIX}.vaccineDateSecond`}
                format={dateFormat}
                defaultPickerValue={moment().clone().set('year', 2020)}
              />
            </FormItem>
          </Fieldset>
        </>
      ) : null}

      {vaccinated === false ? (
        <Alert description="Remember to come back and update your profile when your vaccination has been administered" type="warning" showIcon />
      ) : null}

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
  children: PropTypes.node,
};

Form.defaultProps = {
  isSubmitting: false,
  children: null,
};

export default Form;
